import { BrandLink } from './BrandLink';

export function Footer() {
  return (
    <footer className="py-6 text-center text-xs text-slate-500 dark:text-slate-400">
      <BrandLink />
    </footer>
  );
}
